// Types
import type { TSearchPerformer } from '~/misc/search/types';
import type { TAgent } from '~/misc/agent/types';

// Services
import { AbstractDataClient } from '~/misc/services/data-client';

// Models
import { ManagerAliasesModel } from '~/modules/manager/models/aliases';

export class ManagerAliasesSearchPerformer
  extends AbstractDataClient<ManagerAliasesModel>
  implements TSearchPerformer
{
  constructor() {
    super(new ManagerAliasesModel());
  }

  public searchByQuery(query: string): Promise<TAgent[]> {
    return this.request('search', query);
  }
}
